export default {
  PERSONAL_DATA_VERIFICATION: 'personal_data_verification',
  ID_VERIFICATION_CONFIRM: 'id_verification_confirm',
  ID_VERIFICATION_ROUTING: 'id_verification_routing',
  UAE_ID_VERIFICATION: 'uae_id_verification',
  UAE_UQUDO_VERIFICATION: 'init-uqudo',
  ID_VERIFICATION_KSA_NAFATH_WAITING: 'nafath_id_verification_waiting',
}
